/**
 * Soft duplicate nudge for GR Upload new (Chunk 4).
 * Same primary gate as express: supplier + normalised invoice number.
 */

import { normaliseInvoiceNumberForMultiDoc } from './invoiceMultiDocRules'
import {
  getLinkExistingInvoiceId,
  invoiceMatchesGrSupplier,
  isLinkExistingCandidate,
} from './goodsReceiptingLinkExistingHelpers'

function normaliseSupplierId(value) {
  return String(value || '').trim()
}

function uploadFileMatchesSupplier(file = {}, order = {}) {
  const orderSupplierId = normaliseSupplierId(
    order?.supplier?._id || order?.supplier,
  )
  const fileSupplierId = normaliseSupplierId(file.supplier || file.supplierId)
  if (orderSupplierId && fileSupplierId) {
    return (
      orderSupplierId === fileSupplierId ||
      normaliseSupplierId(order.venueSupplier?._id) === fileSupplierId
    )
  }
  const orderTitle = String(order?.supplier?.title || '')
    .trim()
    .toLowerCase()
  const fileTitle = String(file.supplierTitle || '')
    .trim()
    .toLowerCase()
  if (orderTitle && fileTitle) return orderTitle === fileTitle
  // Prefill order supplier is enough when OCR left supplier blank.
  return Boolean(orderSupplierId || orderTitle)
}

/**
 * Find a strong library duplicate for files about to be confirmed on GR upload.
 *
 * @returns {null | {
 *   uploadFile: object,
 *   existingInvoice: object,
 *   invoiceNumber: string,
 *   existingInvoiceId: string,
 * }}
 */
export function findStrongLibraryDuplicateForGrUpload({
  uploadFiles = [],
  libraryInvoices = [],
  order = {},
} = {}) {
  const files = Array.isArray(uploadFiles) ? uploadFiles : []
  const library = Array.isArray(libraryInvoices) ? libraryInvoices : []

  for (const file of files) {
    if (String(file.documentType || '') === 'creditNote') continue
    const invoiceNumber = String(file.invoiceNumber || '').trim()
    const normalised = normaliseInvoiceNumberForMultiDoc(invoiceNumber)
    if (!normalised) continue
    if (!uploadFileMatchesSupplier(file, order)) continue

    const matches = library.filter(invoice => {
      if (!invoiceMatchesGrSupplier(invoice, order)) return false
      const existingNumber = normaliseInvoiceNumberForMultiDoc(
        invoice.invoiceNumber,
      )
      return Boolean(existingNumber) && existingNumber === normalised
    })

    if (!matches.length) continue

    const preferred =
      matches.find(invoice => isLinkExistingCandidate(invoice)) || matches[0]

    return {
      uploadFile: file,
      existingInvoice: preferred,
      invoiceNumber: preferred.invoiceNumber || invoiceNumber || normalised,
      existingInvoiceId: getLinkExistingInvoiceId(preferred),
    }
  }

  return null
}
